"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var AgreementResource = /** @class */ (function (_super) {
    tslib_1.__extends(AgreementResource, _super);
    function AgreementResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgreementResource.endpoint = '/agreements';
    AgreementResource.MODEL_NAME = 'agreement';
    return AgreementResource;
}(base_1.default));
exports.default = AgreementResource;
//# sourceMappingURL=agreement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/agreement.js
// module id = d+R4
// module chunks = 0